import { __decorate } from "tslib";
import { AutoEncoder, DateDecoder, field, StringDecoder } from '@common/encoding';
/**
 * The account of the administrator behind an impersonated session. Everything the session
 * changes is attributed to this account, not to the impersonated one.
 */
export class ImpersonatedBy extends AutoEncoder {
    id;
    email;
    firstName = null;
    lastName = null;
    get name() {
        if (!this.lastName) {
            return this.firstName ?? '';
        }
        if (!this.firstName) {
            return this.lastName;
        }
        return this.firstName + ' ' + this.lastName;
    }
}
__decorate([
    field({ decoder: StringDecoder })
], ImpersonatedBy.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], ImpersonatedBy.prototype, "email", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], ImpersonatedBy.prototype, "firstName", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], ImpersonatedBy.prototype, "lastName", void 0);
export class StartImpersonationRequest extends AutoEncoder {
    /**
     * The user to sign in as.
     */
    userId;
}
__decorate([
    field({ decoder: StringDecoder })
], StartImpersonationRequest.prototype, "userId", void 0);
export class ImpersonationTicket extends AutoEncoder {
    /**
     * One-time secret that can be traded for a session. Belongs in the fragment of the
     * link, never in the query string: a fragment is not sent to the server and does not
     * end up in referrers or server logs.
     */
    ticket;
    validUntil;
}
__decorate([
    field({ decoder: StringDecoder })
], ImpersonationTicket.prototype, "ticket", void 0);
__decorate([
    field({ decoder: DateDecoder })
], ImpersonationTicket.prototype, "validUntil", void 0);
export class ImpersonationTicketGrant extends AutoEncoder {
    ticket;
}
__decorate([
    field({ decoder: StringDecoder })
], ImpersonationTicketGrant.prototype, "ticket", void 0);
//# sourceMappingURL=Impersonation.js.map